module.exports = __webpack_public_path__ + "img/TECNOLOGIA-SWIFT-BOOSTER-GREEN-4.d9dd3e3e.jpg";